export default __webpack_public_path__ + "static/media/profile_pic_tara.774bd863.png";